import { render, staticRenderFns } from "./Directorio.vue?vue&type=template&id=25bf6f4d&scoped=true&"
import script from "./Directorio.vue?vue&type=script&lang=js&"
export * from "./Directorio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25bf6f4d",
  null
  
)

export default component.exports